module.exports = __webpack_public_path__ + "img/satatlit.c1912457.png";